const isTemplateValue = (value?: string): boolean =>
  !!value && value.startsWith('${') && value.endsWith('}');

const getEnvValue = (key: string): string | undefined => {
  // @ts-ignore - Runtime env from public/config.js
  const runtimeValue = window.ENV?.[key];

  if (!runtimeValue || isTemplateValue(runtimeValue)) {
    return process.env[key];
  }

  return runtimeValue;
};

const getBooleanEnv = (key: string): boolean =>
  getEnvValue(key)?.toLowerCase() === 'true';

export const featureFlags = {
  signUpEnabled: getBooleanEnv('REACT_APP_FEATURE_SIGN_UP_ENABLED'),
  billingAndSubscriptionEnabled: getBooleanEnv(
    'REACT_APP_FEATURE_BILLING_AND_SUBSCRIPTION_ENABLED'
  ),
  isPrivateCloud: getBooleanEnv('REACT_APP_IS_PRIVATE_CLOUD')
};

export const appConfig = {
  shgAdminEmail: getEnvValue('REACT_APP_SHG_ADMIN_EMAIL') || ''
};

export type AuthProvider = 'local' | 'oidc';

export const oidcConfig = {
  authProvider: (getEnvValue('REACT_APP_AUTH_PROVIDER') || 'local') as AuthProvider,
  authority: getEnvValue('REACT_APP_OIDC_AUTHORITY') || '',
  clientId: getEnvValue('REACT_APP_OIDC_CLIENT_ID') || '',
  redirectUri:
    getEnvValue('REACT_APP_OIDC_REDIRECT_URI') || window.location.origin,
  postLogoutRedirectUri:
    getEnvValue('REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI') || `${window.location.origin}/logout`,
  scope: getEnvValue('REACT_APP_OIDC_SCOPE') || 'openid profile email',
};

export const isOidcAuth = (): boolean => oidcConfig.authProvider === 'oidc';
